import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import Topbar from "../../../components/Topbar";
import ApModal from "../../../components/Modal/ApModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";
import CreditorQuickCreateModal from "../../../components/Modal/CreditorQuickCreateModal";

// Model
import { poMasterModel } from "../../../../model/Purchase/PoMasterModel";
import { poDetailModel } from "../../../../model/Purchase/PoDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxDocNo,
  randomDelay,

  deleteData,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
  formatThaiDayMonthShortYear,
} from "../../../../utils/DateUtils";

function Form({ callInitialize, mode, setMode, name, maxDocNo, getReport }) {
  const normalizeDocIsPrc = (value) => {
    if (value === undefined || value === null) {
      return 0;
    }

    if (typeof value === 'number') {
      return value ? 1 : 0;
    }

    if (typeof value === 'boolean') {
      return value ? 1 : 0;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim().toUpperCase();
      if (trimmed === 'Y' || trimmed === 'YES' || trimmed === 'TRUE') {
        return 1;
      }
      if (trimmed === 'N' || trimmed === 'NO' || trimmed === 'FALSE') {
        return 0;
      }
      const parsed = parseInt(trimmed, 10);
      if (!Number.isNaN(parsed)) {
        return parsed ? 1 : 0;
      }
    }

    return 0;
  };
  const fetchApList = async () => {
    const apList = await getDataWithComp("Tb_Set_AP", "ORDER BY AP_Code ASC");
    if (apList && apList.length > 0) {
      setApDataList(apList);
    } else {
      setApDataList([]);
    }
    return apList;
  };
  const handleCreditorSuccess = async (insertedAp) => {
    const apList = await fetchApList();
    setShowCreditorModal(false);
    if (insertedAp) {
      const found = apList
        ? apList.find(
          (a) => String(a.AP_Id) === String(insertedAp.AP_Id) || a.AP_Code === insertedAp.AP_Code
        )
        : null;
      if (found) onRowSelectAp(found);
    }
  };
  const [formMasterList, setFormMasterList] = useState(poMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [showCreditorModal, setShowCreditorModal] = useState(false);

  // Upload File
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      if (updated.length === 0) {
        setOpenUploadAttach(false);
      }
      return updated;
    });
  };
  const handleInputFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }
    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          id: Date.now() + Math.random(),
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          dataUrl: e.target?.result,
          isPending: true,
          displayName: file.name,
        };
        setSelectedFiles((prev) => [...prev, fileData]);
      };
      reader.readAsDataURL(file);
    });
  };
  const handleBeforeUploadAttach = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = true;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // สำหรับส่งไปหน้า FormAction
  const [docStatus, setDocStatus] = useState(null);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      if (mode === "I") {
        const freshMasterRaw = poMasterModel();
        const freshMaster = {
          ...freshMasterRaw,
          docIsPrc: normalizeDocIsPrc(freshMasterRaw.docIsPrc),
        };
        setFormMasterList(freshMaster);
        setFormDetailList([]);
        setDocStatus(freshMaster.docStatus);
        setIsVatChecked(false);
        setSelectedDiscountValueType(freshMaster.discountValueType ? String(freshMaster.discountValueType) : "2");
        setSelectedFiles([]);
        setOpenUploadAttach(false);
        setShowViewAttachModal(false);
      }

      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
        if (mode === "I") {
          setFormMasterList((prev) => ({
            ...prev,
            docType: docTypeList[0]?.DocType_Id || prev.docType,
            docCode: docTypeList[0]?.DocType_DocCode || prev.docCode,
          }));
        }
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
        if (mode === "I") {
          setFormMasterList((prev) => ({
            ...prev,
            transportType: transTypeList[0]?.Trans_TypeID || prev.transportType,
          }));
        }
      }

      const apDataList = await fetchApList();

      const itemDataList = await getDataWithComp(
        "Tb_Set_Item",
        "ORDER By Item_Code ASC",
        {
          fields: [
            "Item_Id",
            "Item_Code",
            "Item_Name",
            "Item_Img",
            "Item_Group",
            "Item_Status"
          ]
        }
      );
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList);

        const findIdByNo = await getDataWithComp(
          "PO_H",
          `AND Doc_No = '${maxDocNo}'`
        );

        if (Array.isArray(findIdByNo) && findIdByNo.length > 0 && findIdByNo[0]?.Doc_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 2 AND Doc_ID = ${findIdByNo[0].Doc_Id}`
          );
          setSelectedFiles(Array.isArray(image) ? image : []);
        } else {
          setSelectedFiles([]);
        }
        setOpenUploadAttach(false);
        setShowViewAttachModal(false);
      } else {
        // Use date-only without timezone offset to avoid +7h shifts
        const currentDate = moment().format('YYYY-MM-DD');
        setFormMasterList((prev) => ({
          ...prev,
          docDate: currentDate,
          docDueDate: currentDate,
          createdDate: getCreateDateTime(),
          createdByName: window.localStorage.getItem('name'),
        }));
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList) => {
    try {
      // ค้นหาข้อมูล PO_H ที่ตรงกับ Doc_No
      const [findMaster] = await Promise.all([getDataWithComp("PO_H", "")]);
      const fromDatabase = findMaster.find((po) => po.Doc_No === maxDocNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AP_ID จาก apDataList
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === fromDatabase.AP_ID
      );

      if (!fromViewAp) {
        throw new Error("ไม่พบข้อมูลผู้ขาย");
      }

      // เดิมมีการตรวจสอบว่า PO นี้มีใบรับหรือไม่ แต่การใช้งานนั้นย้ายออกไป
      // จึงไม่จำเป็นต้องดึงข้อมูล REC_H ที่นี่อีกต่อไป

      // SET สถานะใช้กับ FormAction
      setDocStatus(fromDatabase.Doc_Status);

      // ค้นหาข้อมูล VIEW โดยใช้ Doc_No
      const [findViewMaster] = await Promise.all([
        getDataWithComp("API_0201_PO_H", ""),
      ]);
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);

      let getPrDetailList = [];

      if (fromView) {
        setStatusName(fromView.DocStatus_Name);
        setStatusColour(fromView.DocStatus_Colour);
      }

      // ฟังก์ชันสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (itemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        const prDetail = Array.isArray(getPrDetailList)
          ? getPrDetailList.find((pr) => pr.Item_Id === itemSelected.Item_Id)
          : null;

        const basePriceUnitOld = prDetail
          ? parseCurrency(prDetail.Item_Price_Unit)
          : itemPriceUnit;

        return {
          ...poDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemPriceUnitOld: formatCurrency(basePriceUnitOld, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType,
          itemTotal,
          itemRecQty: formatCurrency(itemSelected.Item_REC_Qty),
          itemRecBalance: formatCurrency(itemSelected.Item_REC_Balance),
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: itemSelected.Item_Desc,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "PO_D",
        fromDatabase.Doc_Id,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate: fromDatabase.Doc_Date ? moment(fromDatabase.Doc_Date).format('YYYY-MM-DD') : null,
          docDueDate: fromDatabase.Doc_DueDate ? moment(fromDatabase.Doc_DueDate).format('YYYY-MM-DD') : null,
          docStatus: fromDatabase.Doc_Status,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docStatusReceive: fromDatabase.Doc_Status_Receive,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPrc: normalizeDocIsPrc(fromDatabase.Doc_Is_PRC),
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate ? moment(fromDatabase.Ref_DocDate).format('YYYY-MM-DD') : null,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          apID: fromDatabase.AP_ID,
          apCode: fromDatabase.AP_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,

          // แสดงรายชื่อผู้ขาย
          apName: fromViewAp.AP_Name,
          apAdd1: fromViewAp.AP_Add1,
          apAdd2: fromViewAp.AP_Add2,
          apAdd3: fromViewAp.AP_Add3,
          apProvince: fromViewAp.AP_Province,
          apZipcode: fromViewAp.AP_Zipcode,
          apTaxNo: fromViewAp.AP_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(fromDatabase.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      // หาค่าสูงของ DocNo ใน PO_H ก่อนบันทึก
      const findMaxDocNo = await getDataWithComp(
        "PO_H",
        "ORDER BY Doc_No DESC"
      );
      const maxDoc = getMaxDocNo(findMaxDocNo, "PO");
      let newMaxDoc = maxDoc;

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบจำนวนของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency("1"),
        doc_status_paid: parseCurrency("1"),
        doc_status_receive: parseCurrency("1"),
        doc_code: parseCurrency(formMasterList.docCode || formMasterList.docType || "2"),
        doc_type: parseCurrency(formMasterList.docType),
        doc_for: formMasterList.docFor,
        doc_is_prc: normalizeDocIsPrc(formMasterList.docIsPrc),
        ref_doc_id: null,
        ref_doc: null,
        ref_doc_date: null,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency("0"),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType),
        discount_cash: parseCurrency(formMasterList.discountCash || 0),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport || 0),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day || 0),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode || "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "PO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        let docRows = [];
        if (getDocIdResponse) {
          if (Array.isArray(getDocIdResponse.data)) {
            docRows = getDocIdResponse.data;
          } else if (getDocIdResponse.data && Array.isArray(getDocIdResponse.data.data)) {
            docRows = getDocIdResponse.data.data;
          }
        }

        if (docRows.length > 0) {
          const docId = parseCurrency(docRows[0].Doc_Id);

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId),
              line: index + 1,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: parseCurrency(item.itemTotal),
              item_rec_qty: parseCurrency(item.itemRecQty),
              item_rec_balance: parseCurrency(item.itemRecBalance),
              item_status: 1,
              wh_id: parseCurrency(item.whId),
              zone_id: parseCurrency("1"),
              lt_id: parseCurrency("1"),
              ds_seq: formatDateTime(new Date()),
              item_desc: item.itemDesc,
            };

            // For Log PO_D
            // console.debug("formDetailData : ", formDetailData);

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-po-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          if (selectedFiles.length > 0) {
            try {
              const pendingFiles = selectedFiles.filter((file) => {
                if (typeof file === "string") {
                  return false;
                }
                return file && typeof file === "object" && file.isPending;
              });

              if (pendingFiles.length > 0) {

                const convertToDataUrls = async (files) => {
                  const promises = files.map((f) => {
                    return new Promise((resolve) => {
                      if (typeof f === "string") return resolve(f);
                      if (f.dataUrl && typeof f.dataUrl === "string" && f.dataUrl.startsWith("data:")) return resolve(f.dataUrl);
                      if (f.file) {
                        const reader = new FileReader();
                        reader.onload = (e) => resolve(e.target.result);
                        reader.onerror = () => resolve(null);
                        reader.readAsDataURL(f.file);
                        return;
                      }
                      resolve(null);
                    });
                  });
                  return Promise.all(promises).then((arr) => arr.filter(Boolean));
                };

                const filesPayload = await convertToDataUrls(pendingFiles);
                const uploadResponse = await Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/upload-file`,
                  {
                    comp_id: window.localStorage.getItem("company"),
                    doc_id: docId,
                    DocCode_ID: 2,
                    upload_by: window.localStorage.getItem("name"),
                    file_status: "Y",
                    files: filesPayload,
                    doc_no_ref: null,
                  }
                );
                if (uploadResponse.data.status !== "SUCCESS") {
                  getAlert(
                    "FAILED",
                    "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง"
                  );
                }
              }
            } catch (error) {
              getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
            }
          }
        }

        setSelectedFiles([]);
        setOpenUploadAttach(false);
        setShowViewAttachModal(false);
        callInitialize();
      }
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบจำนวนของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_status_receive: parseCurrency(formMasterList.docStatusReceive, 10),
        doc_code: parseCurrency(formMasterList.docCode || formMasterList.docType || 0, 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        doc_is_prc: normalizeDocIsPrc(formMasterList.docIsPrc),
        ref_doc_id: null,
        ref_doc: null,
        ref_doc_date: null,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(formMasterList.discountValueType, 10),
        discount_cash: parseCurrency(formMasterList.discountCash || 0),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport || 0),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day || 0, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode || "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
      };

      // For Log PO_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("PO_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseCurrency(formMasterList.docId, 10);

        const detailPromises = formDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_discount: parseCurrency(item.itemDiscount),
            item_distype: item.itemDisType,
            item_total: parseCurrency(item.itemTotal),
            item_rec_qty: item.itemRecQty,
            item_rec_balance: item.itemRecBalance,
            item_status: parseCurrency(item.itemStatus, 10),
            wh_id: parseCurrency(item.whId, 10),
            zone_id: parseCurrency(item.zoneId, 10),
            lt_id: parseCurrency(item.ltId, 10),
            ds_seq: item.dsSeq,
            item_desc: item.itemDesc
          };

          // For Log PO_D
          // console.log("formDetailData : ", formDetailData);

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-po-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        if (selectedFiles.length > 0) {
          try {
            const pendingFiles = selectedFiles.filter((file) => {
              if (typeof file === "string") {
                return false;
              }
              return file && typeof file === "object" && file.isPending;
            });

            if (pendingFiles.length > 0) {
              const convertToDataUrls = async (files) => {
                const promises = files.map((f) => {
                  return new Promise((resolve) => {
                    if (typeof f === "string") return resolve(f);
                    if (f.dataUrl && typeof f.dataUrl === "string" && f.dataUrl.startsWith("data:")) return resolve(f.dataUrl);
                    if (f.file) {
                      const reader = new FileReader();
                      reader.onload = (e) => resolve(e.target.result);
                      reader.onerror = () => resolve(null);
                      reader.readAsDataURL(f.file);
                      return;
                    }
                    resolve(null);
                  });
                });
                return Promise.all(promises).then((arr) => arr.filter(Boolean));
              };

              const filesPayload = await convertToDataUrls(pendingFiles);
              if (filesPayload.length > 0) {
                const uploadResponse = await Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/upload-file`,
                  {
                    comp_id: window.localStorage.getItem("company"),
                    doc_id: docId,
                    DocCode_ID: 2,
                    upload_by: window.localStorage.getItem("name"),
                    file_status: "Y",
                    files: filesPayload,
                    doc_no_ref: null,
                  }
                );
                if (uploadResponse.data.status !== "SUCCESS") {
                  getAlert(
                    "FAILED",
                    "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง"
                  );
                }
              }
            }
          } catch (error) {
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }

        setSelectedFiles([]);
        setOpenUploadAttach(false);
        setShowViewAttachModal(false);
        callInitialize();
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleRecover = async () => {
    try {
      if (!formMasterList.refDocID) {
        const formMasterData = {
          doc_no: formMasterList.docNo,
          doc_status: parseCurrency("2", 10),
          doc_status_receive: parseCurrency("1", 10),
          comp_id: window.localStorage.getItem("company"),
        };

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/recover-po-h`,
          formMasterData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        callInitialize();
        return;
      }

      let docStatusReceive = parseCurrency("3", 10);

      // DELETE PO_D เฉพาะรายการที่ค้างเก็บประวัติทั้งหมด (Where DocId & Item_Status = 0)
      await deleteData(
        "PO_D",
        `WHERE Doc_ID = ${formMasterList.docId} AND Item_Status = 0`
      );

      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("2", 10),
        doc_status_receive: parseCurrency(docStatusReceive, 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/recover-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    const newValue = typeof value === 'string'
      ? value
      : value
        ? value.format('YYYY-MM-DD')
        : null;
    setFormMasterList((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChangeDetail = (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (field !== "itemDesc" && !/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (field === "itemQty") {
      const currentRecQty = parseCurrency(updatedList[index].itemRecQty) || 0;
      const newBalance = Math.max(itemQty - currentRecQty, 0);
      updatedList[index].itemRecBalance = formatCurrency(newBalance, true);
    }

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] = parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(
      numericValue,
      field === "itemQty" || field === "itemPriceUnit"
    );

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;

    if (field === 'itemQty') {
      const currentRecQty = parseCurrency(updatedList[index].itemRecQty) || 0;
      const newBalance = Math.max(numericValue - currentRecQty, 0);
      updatedList[index].itemRecBalance = formatCurrency(newBalance, true);
    }

    setFormDetailList(updatedList);
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      });
      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemPriceUnitOld: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemRecQty: formatCurrency(0),
            itemRecBalance: formatCurrency(0),
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0), 0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(4), true));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Topbar
        breadcrumbs={[
          { label: "จัดซื้อสินค้า", link: "/purchase-order" },
          { label: name, link: "/purchase-order" },
          { label: mode === "U" ? "เรียกดู" + name : "สร้าง" + name },
        ]}
      />
      <CreditorQuickCreateModal
        show={showCreditorModal}
        onClose={() => setShowCreditorModal(false)}
        onSuccess={handleCreditorSuccess}
      />
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase-order" },
          { name: name, url: "/purchase-order" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => {
          const status = formMasterList?.Doc_Status ?? formMasterList?.docStatus ?? formMasterList?.DocStatus;
          if (String(status) === '13') return;
          getReport("po", formMasterList.docNo);
        }}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
      />
      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <DatePicker
              label="วันที่เอกสาร"
              name="docDate"
              value={formMasterList.docDate}
              onChange={(date) => handleChangeDateMaster(date, "docDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.apCode || "") +
                    " " +
                    (formMasterList.apName || "")
                  }
                  readOnly
                  disabled={mode === "U" && docStatus !== 1}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  type="button"
                  disabled={mode === "U" && docStatus !== 1}
                >
                  <i className="fas fa-search"></i>
                </button>
                <button
                  className="btn btn-outline-success"
                  onClick={() => setShowCreditorModal(true)}
                  type="button"
                  disabled={mode === "U" && docStatus !== 1}
                  title="สร้างผู้ขายใหม่"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formatThaiDayMonthShortYear(formMasterList.createdDate)}
                //onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={mode === "U" && docStatus !== 1}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.apAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMaster}
                disabled={mode === "U" && docStatus !== 1}
                className="form-select form-control input-spacing"
              >
                <option value="1">ซื้อมาเพื่อใช้</option>
                <option value="2">ซื้อมาเพื่อขาย</option>
              </select>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formatThaiDayMonthShortYear(formMasterList.updateDate) || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <DatePicker
              label="วันที่จัดส่ง"
              name="docDueDate"
              value={formMasterList.docDueDate}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              disabled={mode === "U" && docStatus !== 1}
            />
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apProvince || "") +
                  " " +
                  (formMasterList.apZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                disabled={mode === "U" && docStatus !== 1}
                className="form-select form-control input-spacing"
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.apTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4"></div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            {/* <DatePicker
              label="วันที่จัดส่ง"
              name="docDueDate"
              value={formMasterList.docDueDate}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              disabled={mode === "U" && docStatus !== 1}
            /> */}
          </div>
          <div className="col-12 col-md-6 col-lg-4"></div>
          <div className="col-12 col-md-6 col-lg-4"></div>
        </div>
        <div className="row mt-1 purchase-form-row">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                disabled={mode === "U" && docStatus !== 1}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
                disabled={mode === "U" && docStatus !== 1}
              />
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-6">
          </div>
          <div className="col-6">
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={mode === "U" && docStatus !== 1}
            docType={formMasterList.docType}
            docStatus={docStatus}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={mode === "U" && docStatus !== 1}
          />
        </div>
      </div>
      <br />
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onRecover={handleRecover}
        docStatus={docStatus}
        mode={mode}
        setMode={setMode}
        disabled={docStatus === 1 ? false : true}
        footer={true}
      />
    </>
  );
}

export default Form;
